import axiosInstance from '../../utility/axios';
import { POST_TYPE_NAME } from '../../utility/constants';

export const showError = (errorMessage) => ({
    type: 'SHOW_ERROR',
    errorMessage
});

export const startOnlineStat = () => ({
    type: 'START_GET_ONLINE_STAT',
});

export const getOnlineStatSuccess = (emailStat) => ({
    type: 'GET_ONLINE_STAT_SUCCESS',
    emailStat
});

export const getOnlineStat = (id) => {
    return (dispatch) => {
        dispatch(startOnlineStat());
        axiosInstance.get(`online-stat/${id}`)
            .then((response) => {
                if (response.data.job === false) { // no post yet
                } else { // has post
                    console.log('response.data in email stat: ', response.data);
                    dispatch(getOnlineStatSuccess(response.data));
                }
            })
            .catch((error) => {
                dispatch(showError(error));
                console.log(error);
            });
    }
};

export const startGetOnlineStats = () => ({
    type: 'START_GET_ONLINE_STATS',
});

export const getOnlineStatsSuccess = (onlineStats) => ({
    type: 'GET_ONLINE_STATS_SUCCESS',
    onlineStats
});

export const getOnlineStats = (queryParams) => {
    console.log('getOnlineStats');

    return (dispatch) => {
        let url = 'online-stats-all';
        if (queryParams) {
            url = `online-stats-all/${queryParams}`;
        }
        console.log('get stats-email url: ', url);
        dispatch(startGetOnlineStats());
        axiosInstance.get(url)
            .then((response) => {
                dispatch(getOnlineStatsSuccess(response.data));
            })
            .catch((error) => {
                dispatch(showError(error));
                console.log(error);
            });
    }
};

export const startCreateStatsEmail = () => ({
    type: 'START_CREATE_STATS_EMAIL'
});

export const createStatsEmailSuccess = (onlineStat) => ({
    type: 'CREATE_STATS_EMAIL_SUCCESS',
    onlineStat
});

export const createStatsEmail = (onlineStat) => {
    console.log('creating stats-email', onlineStat);
    return (dispatch) => {
        dispatch(startCreateStatsEmail());
        axiosInstance.post('online-stat', onlineStat)
            .then((response) => {
                dispatch(createStatsEmailSuccess(response.data));
            })
            .catch((error) => {
                dispatch(showError());
                console.log(error);
            });
    }
};

export const startOnlineStatUpdate = () => ({
    type: 'START_ONLINE_STAT_UPDATE',
});

export const updateOnlineStatSuccess = (emailStatDetails) => ({
    type: 'UPDATE_ONLINE_STAT_SUCCESS',
    emailStatDetails
});

export const updateOnlineStat = (emailStatDetails, emailStatId) => {
    return (dispatch) => {
        dispatch(startOnlineStatUpdate());
        axiosInstance.put(`online-stat-all/${emailStatId}`, emailStatDetails)
            .then((response) => {
                dispatch(updateOnlineStatSuccess(emailStatDetails));
            })
            .catch((error) => {
                dispatch(showError(error));
                console.log(error);
            });
    }
};

export const startOnlineStatPriorityUpdate = () => ({
    type: 'START_ONLINE_STAT_PRIORITY_UPDATE',
});

export const updateOnlineStatPrioritySuccess = (formattedStats) => ({
    type: 'UPDATE_ONLINE_STAT_PRIORITY_SUCCESS',
    formattedStats
});

export const updateOnlineStatPriority = (onlineStats, priority) => {

    let formattedStats = {
        itemsToUpdate: onlineStats,
        priority: priority
    }

    return (dispatch) => {
        dispatch(startOnlineStatPriorityUpdate());
        axiosInstance.put(`online-stats-all`, formattedStats)
            .then((response) => {
                dispatch(updateOnlineStatPrioritySuccess(formattedStats));
            })
            .catch((error) => {
                dispatch(showError(error));
                console.log(error);
            });
    }
};

export const startRemoveStatsEmails = () => ({
    type: 'START_REMOVE_STATS_EMAIL'
});

export const removeStatsEmailsSuccess = (jobIds) => ({
    type: 'REMOVE_STATS_EMAIL_SUCCESS',
    jobIds
});

export const removeStatsEmails = (jobIds) => {
    return (dispatch) => {
        const items = {
            itemsToDelete: jobIds
        };
        dispatch(startRemoveStatsEmails());
        axiosInstance.delete('onlineStats', { data: items })
            .then((response) => {
                dispatch(removeStatsEmailsSuccess(jobIds));
                console.log('onlineStats removed!');
            })
            .catch((error) => {
                dispatch(showError());
                console.log(error);
            });
    }
};

